'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var listPopover = require('@arrive/list-popover');
var TextEntry = require('@arrive/text-entry');
var SVGIcon = require('@arrive/svg-icon');
var CHECK = require('@arrive/ui-icons/svg/ic_check.svg');
var CARET = require('@arrive/ui-icons/svg/ic_drawer.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var TextEntry__default = /*#__PURE__*/_interopDefaultLegacy(TextEntry);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var CHECK__default = /*#__PURE__*/_interopDefaultLegacy(CHECK);
var CARET__default = /*#__PURE__*/_interopDefaultLegacy(CARET);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","popoverCaret":"arrive_SelectableListPopover__popoverCaret","popTextEntry":"arrive_SelectableListPopover__popTextEntry"};

var _excluded = ["onChange", "isMulti", "options", "selectedOptionIds", "setShowPopover", "closeOnSingleSelect", "children", "selectOnEnter", "id", "withCheckbox"],
    _excluded2 = ["children", "className", "isDisabled", "isSelected", "withCheckbox"],
    _excluded3 = ["showPopover", "value", "isMulti", "selectedOptionText", "backspaceClear", "tabSelect", "onSelectionChange", "onChange", "onFocus", "classes", "readOnly", "id"];
var SelectableListPopover = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var onChange = _ref.onChange,
      isMulti = _ref.isMulti,
      options = _ref.options,
      selectedOptionIds = _ref.selectedOptionIds,
      setShowPopover = _ref.setShowPopover,
      closeOnSingleSelect = _ref.closeOnSingleSelect,
      children = _ref.children,
      _ref$selectOnEnter = _ref.selectOnEnter,
      selectOnEnter = _ref$selectOnEnter === void 0 ? true : _ref$selectOnEnter,
      id = _ref.id,
      withCheckbox = _ref.withCheckbox,
      rest = _objectWithoutProperties(_ref, _excluded);

  var selectedOptionsAsSet = new Set(selectedOptionIds);
  var listItems = options.map(function (item) {
    var isSelected = selectedOptionsAsSet.has(item.id);

    var handleItemClick = function handleItemClick(evt) {
      if (evt) {
        evt.stopPropagation();
        evt.preventDefault();
      }

      if (isMulti) {
        var copy = new Set(selectedOptionsAsSet);

        if (isSelected) {
          copy.delete(item.id);
        } else {
          copy.add(item.id);
        }

        onChange(Array.from(copy), item.id);
      } else {
        if (isSelected) {
          onChange([]);
        } else {
          onChange([item.id]);
        }

        if (closeOnSingleSelect) {
          setShowPopover(false);
        }
      }
    };

    var handleKeyDown = function handleKeyDown(evt) {
      if (!item.disabled && selectOnEnter && evt.key === 'Enter') {
        handleItemClick(evt);
      }
    };

    return /*#__PURE__*/React__default["default"].createElement(SelectablePopoverListItem, {
      className: cx__default["default"](item.className, _defineProperty({}, item.selectedClass, isSelected && item.selected)),
      isDisabled: item.disabled,
      isSelected: isSelected,
      key: item.id,
      onClick: handleItemClick,
      onKeyDown: handleKeyDown,
      withCheckbox: withCheckbox
    }, item.content);
  });
  return /*#__PURE__*/React__default["default"].createElement(listPopover.ListPopover, _extends({
    id: id,
    listItems: listItems,
    setShowPopover: setShowPopover,
    ref: ref
  }, rest), children);
});
SelectableListPopover.displayName = "SelectableListPopover";
SelectableListPopover.propTypes = {
  onChange: PropTypes__default["default"].func.isRequired,
  isMulti: PropTypes__default["default"].bool,
  options: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    className: PropTypes__default["default"].string,
    content: PropTypes__default["default"].node,
    disabled: PropTypes__default["default"].bool,
    id: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number]),
    selectedClass: PropTypes__default["default"].string
  })),

  /**
   * This will be an array no matter if it is single select or multi-select. Single select will just always only have one item in the array
   */
  selectedOptionIds: PropTypes__default["default"].arrayOf(PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])),
  closeOnSingleSelect: PropTypes__default["default"].bool,
  selectOnEnter: PropTypes__default["default"].bool,
  classes: PropTypes__default["default"].shape({
    anchorClass: PropTypes__default["default"].string,
    contentContainerClass: PropTypes__default["default"].string,
    listContainerClass: PropTypes__default["default"].string
  }),
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]).isRequired,
  matchAnchorWidth: PropTypes__default["default"].bool,
  placement: PropTypes__default["default"].string,
  showPopover: PropTypes__default["default"].bool.isRequired,
  setShowPopover: PropTypes__default["default"].func.isRequired,
  focusLockProps: PropTypes__default["default"].object,
  id: PropTypes__default["default"].string,
  withCheckbox: PropTypes__default["default"].bool
};
function SelectablePopoverListItem(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      isDisabled = _ref2.isDisabled,
      isSelected = _ref2.isSelected,
      withCheckbox = _ref2.withCheckbox,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React__default["default"].createElement(listPopover.PopoverListItem, _extends({
    "aria-selected": isSelected,
    className: className,
    icon: CHECK__default["default"],
    isDisabled: isDisabled,
    keepIconSpace: true,
    showIcon: isSelected,
    withCheckbox: withCheckbox
  }, rest), children);
}
SelectablePopoverListItem.propTypes = {
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),
  className: PropTypes__default["default"].string,
  id: PropTypes__default["default"].string,
  isDisabled: PropTypes__default["default"].bool,
  isSelected: PropTypes__default["default"].bool,
  onClick: PropTypes__default["default"].func,
  withCheckbox: PropTypes__default["default"].bool
};
var ListPopoverTextEntry = /*#__PURE__*/React__default["default"].forwardRef(function (_ref3, ref) {
  var showPopover = _ref3.showPopover,
      value = _ref3.value,
      _ref3$isMulti = _ref3.isMulti,
      isMulti = _ref3$isMulti === void 0 ? false : _ref3$isMulti,
      selectedOptionText = _ref3.selectedOptionText,
      _ref3$backspaceClear = _ref3.backspaceClear,
      backspaceClear = _ref3$backspaceClear === void 0 ? true : _ref3$backspaceClear,
      _ref3$tabSelect = _ref3.tabSelect,
      tabSelect = _ref3$tabSelect === void 0 ? false : _ref3$tabSelect,
      onSelectionChange = _ref3.onSelectionChange,
      _onChange = _ref3.onChange,
      onFocus = _ref3.onFocus,
      _ref3$classes = _ref3.classes,
      classes = _ref3$classes === void 0 ? {} : _ref3$classes,
      readOnly = _ref3.readOnly,
      id = _ref3.id,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var readbackText = value;

  if (!isMulti) {
    readbackText = selectedOptionText || value || '';
  }

  return /*#__PURE__*/React__default["default"].createElement(TextEntry__default["default"], _extends({
    id: id,
    classes: _objectSpread2({
      container: cx__default["default"](classes.container, styles.popTextEntry)
    }, classes),
    suffix: !showPopover && !readOnly ? /*#__PURE__*/React__default["default"].createElement("div", {
      onClick: onFocus
    }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
      className: styles.popoverCaret,
      svgRef: CARET__default["default"]
    })) : null,
    value: readbackText,
    ref: ref,
    onChange: function onChange(evt) {
      _onChange(evt.target.value);
    },
    readOnly: readOnly,
    onKeyDown: function onKeyDown(evt) {
      if (!isMulti && backspaceClear && evt.key === 'Backspace' && selectedOptionText) {
        onSelectionChange([]);

        _onChange(selectedOptionText.slice(0, selectedOptionText.length));
      }

      if (!isMulti && tabSelect && evt.key === 'Tab') {
        tabSelect();
      }
    }
  }, props));
});
ListPopoverTextEntry.displayName = 'ListPopoverTextEntry';
ListPopoverTextEntry.propTypes = {
  showPopover: PropTypes__default["default"].bool.isRequired,
  value: PropTypes__default["default"].string.isRequired,
  isMulti: PropTypes__default["default"].bool,
  selectedOptionText: PropTypes__default["default"].string,
  backspaceClear: PropTypes__default["default"].bool,
  tabSelect: PropTypes__default["default"].func,
  onSelectionChange: PropTypes__default["default"].func,
  onChange: PropTypes__default["default"].func.isRequired,
  onFocus: PropTypes__default["default"].func,
  classes: PropTypes__default["default"].object,
  id: PropTypes__default["default"].string
};
ListPopoverTextEntry.defaultProps = {
  onFocus: function onFocus() {}
};

exports.ListPopoverTextEntry = ListPopoverTextEntry;
exports.SelectablePopoverListItem = SelectablePopoverListItem;
exports["default"] = SelectableListPopover;
